import { getXPartner, setXPartnerfromQueryString } from "@/app/utils/helper";

interface Headers {
    [key: string]: string;
}

const requestHeaders: Headers = {
    "X-partner": getXPartner(),
};

const requestOptions: RequestInit = {
    headers: requestHeaders,
};

export const getFDListData = async () => {
    try {
        setXPartnerfromQueryString();
        const response = await fetch(`${process.env.API_BASE_URL}/fixedDeposits/fd`, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};